import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { logoutUser } from "../../store/actions";

//redux
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { handleErrors } from "components/Common/common";

const Logout = () => {
  const history = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {

    const handleLogout = async () => {
      try {
        sessionStorage.clear()
        await axiosInstance.post(ApiNames.USER_SIGNOUT)
        dispatch(logoutUser(history));
      } catch (e) {
        console.error(e);
        handleErrors(e)
      }
    }
    handleLogout()
  }, [dispatch, history]);

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);